import { ProfilePageContainer } from "@/components/container/profile-page-container";
import { useStepRouteInfo } from "@/hooks/use-step-route-info";
import { useIonRouter } from "@ionic/react";
import MealCreatingProgress from "../../components/meal-creating-progress";
import { useCheckAllCandidateCreation } from "../../hooks/use-check-all-candidate-creation";

export default function OnboardingGoToCandidatesCreating() {
  const { info } = useStepRouteInfo();
  const navigation = useIonRouter();
  useCheckAllCandidateCreation({
    onCompleted: () => {
      navigation.push(info?.nextPath ?? "", "none");
    },
  });
  return (
    <ProfilePageContainer
      showToolbar={false}
      className="h-full flex flex-col items-center justify-center"
    >
      <MealCreatingProgress />
    </ProfilePageContainer>
  );
}
